import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/http'
import Clipboard from 'vue-clipboard2'
import global from './global' // 全局配置

import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(Clipboard)

// 注册全局配置
global.install = function () {
  Object.defineProperty(Vue.prototype, '$g', {
    get () {
      return global
    }
  })
}
Vue.use(global)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
